import { client } from "@client";
import { GetFeatureFlagProps, Routes, StorageKey, UserQuery } from "@ctypes";
import { FEATURE_FLAGS } from "@graphql";
import { clearSessionFromStorage } from "./auth";
import { getMissingFieldRoute } from "./onboarding";

const DEFAULT_TIME_TO_SLEEP_IN_MS = 2000;

export const sleep = (timeInMilliSeconds = DEFAULT_TIME_TO_SLEEP_IN_MS) => {
  return new Promise((resolve) => setTimeout(resolve, timeInMilliSeconds));
};

export const getRouteForPath = (path?: string) => {
  if (!path) return null;

  const routes = Object.keys(Routes);
  const paths = Object.values(Routes);

  const index = paths.findIndex((p) => p === path);

  if (index === -1) {
    return Routes.Fallback;
  }

  return routes[index] as Routes;
};

export const getNextRoute = () => {
  const token = localStorage.getItem(StorageKey.Token);
  const user = localStorage.getItem(StorageKey.User);

  if (token && user) {
    const data = JSON.parse(user) as UserQuery;

    const route = getMissingFieldRoute(data);

    if (route) {
      return Routes.Onboarding;
    }

    return Routes.Dashboard;
  } else {
    clearSessionFromStorage();
    return Routes.Auth;
  }
};

export const getFeatureFlag = ({ featureFlags, value }: GetFeatureFlagProps): boolean => {
  return featureFlags?.featureFlags?.find((flag) => flag.name === value)?.value ?? false;
};

export const readFeatureFlagsFromCache = () => {
  return client.readQuery({
    query: FEATURE_FLAGS,
  });
};
